module.exports = __webpack_public_path__ + "img/capa2.20de55ea.webp";